import xhr from 'xhr';

class ExistingSession {
  constructor(url) {
    this.url = url;
  }

  handle() {
    xhr(this.url, {
      credentials: 'include',
      onSuccess: this.redirectToChoiceScreen
    });
  }

  redirectToChoiceScreen(response) {
    window.location = `${response.location}?product=papertrail`;
  }
}

PT.SWICUS.ExistingSession = ExistingSession;